<template>
  <Btn :label="$t('ELE0251')" icon="mdi-content-copy" isCheckRole @click="onClick" :disabled="disabled" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'BtnCopy',

  components: {
    Btn,
  },

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
